(function ($) {

    $(document).ready(function ($) {

        if ($('.contact-form').length) {

            $('.how_can_we_help label').each(function () {

                var input = $(this).find('input[name=how_can_we_help]').val();


                if (input == "Soporte de Hotel" || input == "Hotelunterstützung" || input == "Support d'hôtel") {
                    input = "Hotel Support";
                }
                if (input == "Agencia de Viajes de Apoyo" || input == "Reisebürounterstützung" || input == "Support d'agence de voyage") {
                    input = "Travel Agency Support";
                }
                if (input == "Medios de Investigación" || input == "Medienanfrage" || input == "Enquête sur les médias") {
                    input = "Media Inquiry";
                }
                if (input == "Carreras" || input == "Karriere" || input == "Carrières") {
                    input = "Careers";
                }
                if (input == "Otro" || input == "Andere" || input == "Autre") {
                    input = "Other";
                }


                if (input == "Consulta de Ventas Hoteleras" || input == "Hotelverkaufsanfrage" || input == "Enquête sur les ventes d'hôtels") {
                    input = "Hotel Sales Inquiry";
                }
                if (input == "Consulta de ventas de agentes de viajes" || input == "Reisebüro Verkaufsanfrage" || input == "Demande de vente d'agent de voyage") {
                    input = "Travel Agent Sales Inquiry";
                }

                $(this).find('input[name=how_can_we_help]').attr('value', input);

                //console.log($(this).find('input[name=how_can_we_help]').attr('value'));

            });

            $('#typeofInquiry').change(function (e) {
                if ($(this).val() == 'Travel Agency Support') {
                    $('.section-form .iATA_wrap').show();
                }else{
                    $('.section-form .iATA_wrap').hide();
                }

            })
        }


    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/hubspot-form.js